import {
  ARCHIVE_STATUS_CHILDREN,
  ARCHIVE_STATUS_ENTRY,
} from "fleet/constant/media-library";
import { PropTypeMediaEntry } from "fleet/prop-types";
import { getArchiveStatus } from "fleet/view/media-library/utils";
import PropTypes from "prop-types";
import React from "react";
import Alert from "react-bootstrap/Alert";

function ContentArchived(props) {
  const { mediaEntry, parentOnly } = props;
  const { friendlyType } = mediaEntry;
  const archiveStatus = getArchiveStatus(mediaEntry);

  if (!archiveStatus) {
    return null;
  }

  if (archiveStatus === ARCHIVE_STATUS_CHILDREN && parentOnly) {
    return null;
  }

  const archiveTitle =
    archiveStatus === ARCHIVE_STATUS_ENTRY
      ? `This ${friendlyType} is archived.`
      : `This ${friendlyType} contains archived content.`;

  return (
    <Alert className="alert-archived-content">
      <i className="fa fa-warning" />
      {archiveTitle}
      <p>
        <small>
          It will still play, but you cannot add it to other strategies.
        </small>
      </p>
    </Alert>
  );
}

ContentArchived.propTypes = {
  mediaEntry: PropTypeMediaEntry,
  parentOnly: PropTypes.bool,
};

export { ContentArchived };
